import React from 'react';

interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  label?: string;
  errorMessage?: string;
  multiline?: boolean;
  rows?: number;
  onChange?: (e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export function Input({
  label,
  errorMessage,
  multiline,
  rows = 3,
  required,
  className = '',
  onChange,
  ...props
}: InputProps) {
  const baseClasses =
    'w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm placeholder:text-gray-400 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary disabled:cursor-not-allowed disabled:opacity-50';
  const errorClasses = errorMessage ? 'border-red-400 focus:ring-red-300 focus:border-red-400' : '';

  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label className="text-sm font-semibold text-gray-700">
          {label}
          {required && <span className="text-red-500 ml-0.5">*</span>}
        </label>
      )}
      {multiline ? (
        <textarea
          rows={rows}
          required={required}
          className={`${baseClasses} ${errorClasses} ${className}`}
          onChange={onChange as any}
          {...(props as any)}
        />
      ) : (
        <input
          required={required}
          className={`${baseClasses} ${errorClasses} ${className}`}
          onChange={onChange}
          {...props}
        />
      )}
      {errorMessage && <span className="text-xs text-red-600">{errorMessage}</span>}
    </div>
  );
}
